import React from 'react';
import PropTypes from 'prop-types';

import styles from './MessageBubble.module.css';

// The chat message bubble shared by the live chat and the FAQ answer preview.
// `sender` picks the user (right, blue) vs bot (left, grey) variant; callers
// supply the content as children (plain text, markdown, plus any meta/retry
// affordances). Keeping geometry + colour here means the two call sites can't
// drift apart. `className` is an escape hatch for one-off layout tweaks.
export default function MessageBubble({ sender, children, className = '', ...rest }) {
    const variant = sender === 'user' ? styles.user : styles.bot;
    const bubbleClass = [styles.bubble, variant, className].filter(Boolean).join(' ');

    return (
        <div className={bubbleClass} {...rest}>
            {children}
        </div>
    );
}

MessageBubble.propTypes = {
    // 'user' -> right-aligned blue bubble; anything else -> left-aligned bot bubble.
    sender: PropTypes.string.isRequired,
    children: PropTypes.node,
    className: PropTypes.string,
};
